import { graphql, useStaticQuery } from 'gatsby'

/**
 * @property en_MY
 * @property es_CL
 * @property es_PE
 * @property pt_BR
 */
export const onlineChartInfoQuery = graphql`
  query onlineChartInfoQuery {
    es_PE: allMdx(
      filter: { fileAbsolutePath: { regex: "/es-pe/online-chart-info/" } }
    ) {
      edges {
        node {
          id
          body
          excerpt
          frontmatter {
            currency
            kitPrice
            separator
          }
        }
      }
    },
    es_CL: allMdx(
      filter: { fileAbsolutePath: { regex: "/es-cl/online-chart-info/" } }
    ) {
      edges {
        node {
          id
          body
          excerpt
          frontmatter {
            currency
            kitPrice
            separator
          }
        }
      }
    },
    es_CO: allMdx(
      filter: { fileAbsolutePath: { regex: "/es-co/online-chart-info/" } }
    ) {
      edges {
        node {
          id
          body
          excerpt
          frontmatter {
            currency
            kitPrice
            separator
          }
        }
      }
    }
  }
`

const useOnlineChartInfo = () => useStaticQuery(onlineChartInfoQuery)

export default useOnlineChartInfo
